import { useEffect } from 'react';
import { useSelector } from 'react-redux';
import { Buttons, FlexContainer, Spinner, Text } from '@taxdown/piccolo-web';
import { locizeNS } from 'Services/i18n';
import EventService from 'Services/events';
import { history } from 'Store';
import { routeStateSelector } from 'Store/modules/router/selectors';
import { useTranslation } from 'Hooks/useTranslation';
import { useFetchRequestInstantRefund, useSaveInstantRefund } from 'Containers/Result/hooks';
import CustomTransition from 'Components/CustomTransition';
import OneColLayout from 'Components/Layouts/OneColLayout';
import { routes } from 'Constants/routes';
import { PayLaterInfo } from '../PayLaterInfo';
import * as Styled from '../styles';

const InstantRefundActive = (): JSX.Element => {
  const { t } = useTranslation(locizeNS.FILING);
  const infoSubscription = useSelector(routeStateSelector);
  const { mutate, isSuccess } = useSaveInstantRefund();
  const { data, isLoading } = useFetchRequestInstantRefund();

  useEffect(() => {
    if (isSuccess || data) {
      history.push(routes.FILING_CLABE_FLEX, {
        isInstantRefund: true,
      });
    }
  }, [isSuccess, data]);

  const handleClick = (): void => {
    EventService.instantRefundSelected();
    mutate({});
  };

  return (
    <OneColLayout>
      <CustomTransition start>
        <Styled.Container direction="column" align="center" fullWidth fullHeight>
          {isLoading ? (
            <FlexContainer align="center" justify="center" fullHeight>
              <Spinner size="M" align="center" justify="center" />
            </FlexContainer>
          ) : (
            <>
              <Styled.Header align="center" justify="center" direction="column" gap="dimension_08">
                <Text type="paragraphs" size="XL_XL_S" color="success_strong" align="center">
                  {t('Filing.instant.refund.active.title')}
                </Text>
                <Text type="paragraphs" size="S_M_S" color="success_strong">
                  {t('Filing.instant.refund.active.subtitle')}
                </Text>
              </Styled.Header>
              <Styled.ContentContainer direction="column" gap="dimension_32">
                <PayLaterInfo result={infoSubscription?.result} />
                <Buttons.Tiny
                  label={t('InstantRefund.sat.cancel')}
                  onClick={() => history.push(routes.FILING_CLABE_FLEX)}
                />
              </Styled.ContentContainer>
              <FlexContainer justify="center" gap="dimension_24" fullWidth>
                <Buttons.Classic
                  size="m"
                  mode="success"
                  label={t('InstantRefund.active.label')}
                  onClick={handleClick}
                />
              </FlexContainer>
            </>
          )}
        </Styled.Container>
      </CustomTransition>
    </OneColLayout>
  );
};

export default InstantRefundActive;
